import React from 'react';

import PropTypes from 'prop-types';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';


const disableSundayFunc = (date) => {
    return date.getDay() === 0;
};


// https://mui.com/x/api/date-pickers/date-picker/

// Le timezone n'a pas l'air d'être pris en compte, .... ie packing list à -1h

// Faire un toDateString() avant l'envoi au back

const MyDatePicker = ({ label, value, onChange, required, disableSunday, disableFuture, disablePast, format, toolbarFormat, views, helperText, ...rest }) => {

    return (

        <DatePicker
            timezone="Europe/Paris"
            views={views}
            format={format}
            label={label}
            value={value}
            onChange={onChange}

            closeOnSelect={false}

            slotProps={{
                textField: {
                    variant: 'outlined',
                    helperText: helperText
                },
                inputAdornment: { position: 'start' },
                toolbar: {
                    toolbarPlaceholder: '__',
                    toolbarFormat: toolbarFormat,
                    hidden: false,
                },

                actionBar: ({ wrapperVariant }) => ({
                    actions: wrapperVariant === 'desktop' ? ["accept", "cancel", "clear", "today"] : [],
                }),

            }}

            localeText={{
                //datePickerToolbarTitle: `tool bar de ${label} `, // "Choisir une date"

                // A surcharger si besoin
                //clearButtonLabel: 'Effacer',
                //cancelButtonLabel: 'Annuler',
                //todayButtonLabel: "Aujourd'hui",
                //validButtonLabel: 'Valider',

            }}

            disableHighlightToday={false}

            showDaysOutsideCurrentMonth={true}
            disableOpenPicker={false}
            clearable={!required}

            shouldDisableDate={disableSunday ? disableSundayFunc : () => { return false; }}

            disableFuture={disableFuture}
            disablePast={disablePast}
            sx={{ paddingBottom: '8px' }}

            {...rest}

        />
    );
};



MyDatePicker.propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.object,
    onChange: PropTypes.func.isRequired,

    required: PropTypes.bool,
    disableFuture: PropTypes.bool,
    disablePast: PropTypes.bool,
    disableSunday: PropTypes.bool,

    format: PropTypes.string,
};


MyDatePicker.defaultProps = {
    value: '',
    required: false,
    disableFuture: false,
    disablePast: false,
    disableSunday: false,
    format: 'dd/MM/yyyy',
    toolbarFormat: 'dd / MM / yyyy',
    views: ['year', 'month', 'day']
};

export default MyDatePicker;
